import { toast } from "sonner";

import { m } from "@recobra/i18n/messages";

import { downloadFromUrl } from "../lib";
import { documentsApi } from "../lib/api";

export const runDownloadCaseDocumentsZip = async (caseId: string): Promise<boolean> => {
  try {
    const { downloadUrl } = await documentsApi.buildCaseDocumentsArchive(caseId);
    downloadFromUrl(downloadUrl);

    return true;
  } catch (err) {
    console.error(`[documents] case ${caseId} archive download failed:`, err);
    toast.error(m.doc_download_all_error());

    return false;
  }
};
